import { categories } from "@/mocks/categories";

export default function Footer() {
  const linkGroups = [
    {
      title: "Top Categories",
      items: categories.slice(0, 5),
    },
    {
      title: "More Categories",
      items: categories.slice(5, 10),
    },
    {
      title: "All Categories",
      items: categories.slice(10),
    },
  ];

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row justify-between gap-10 mb-14">
          <div className="max-w-xs">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-grid-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-background-50">
                pandabuy<span className="text-accent-400">.bond</span>
              </span>
            </div>
            <p className="text-background-50/50 text-sm leading-relaxed">
              The #1 updated pandabuyspreadsheet hub for fashion and sneakers. Curated daily with
              structured comparison tables — no spam, no duplicates, just clean data.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 flex-1 lg:max-w-2xl">
            {linkGroups.map((group) => (
              <div key={group.title}>
                <h4 className="text-xs font-semibold text-background-50/40 uppercase tracking-wider mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.items.map((cat) => (
                    <li key={cat.name}>
                      <a
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-background-50/55 text-sm hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {cat.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-50/10 gap-6">
          <div className="flex flex-col sm:flex-row items-center gap-4 text-xs text-background-50/40">
            <span>&copy; pandabuy.bond 2025 — All rights reserved.</span>
            <div className="flex items-center gap-4">
              <a href="#" className="hover:text-background-50/60 transition-colors cursor-pointer">Privacy</a>
              <a href="#" className="hover:text-background-50/60 transition-colors cursor-pointer">Terms</a>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 rounded-full bg-accent-500 text-background-50 text-xs font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Pandabuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 rounded-full border border-background-50/20 text-background-50/70 text-xs font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}